import {
    Badge,
    Box,
    Button,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { faSpinnerThird, faTimeline } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';

import EventsTable from './EventsTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ResourceEventsModal = ({
    title,
    httpQueryFn,
    queryKey,
    openTab,
    opened,
    close,
}) => {
    const [activeTab, setActiveTab] = useState('events');
    useEffect(() => {
        setActiveTab(openTab);
    }, [openTab]);

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size='auto'>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <Tabs
                        value={activeTab}
                        onChange={setActiveTab}>
                        <Tabs.List>
                            <Tabs.Tab
                                value='events'
                                leftSection={
                                    <FontAwesomeIcon icon={faTimeline} />
                                }>
                                Events
                            </Tabs.Tab>
                        </Tabs.List>

                        <Tabs.Panel
                            value='events'
                            py={'sm'}>
                            <EventsTable
                                httpQueryFn={httpQueryFn}
                                queryKey={queryKey}
                                enabled={opened}
                            />
                        </Tabs.Panel>
                    </Tabs>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default ResourceEventsModal;
